import { create } from 'zustand'
import type { NormalizedError } from '@/shared/lib/errorReport/errorReport'

export type FeedbackType = 'bug' | 'feature' | 'general'

export interface ErrorContext {
  report: NormalizedError
  url?: string
  timestamp?: string
  /** Page screenshot captured at report time; null when capture failed. */
  screenshot?: Blob | null
}

interface FeedbackStore {
  // Feedback modal state
  isFeedbackOpen: boolean
  feedbackType: FeedbackType

  // Error report modal state
  isErrorReportOpen: boolean
  errorContext: ErrorContext | null

  // Actions
  openFeedback: (type?: FeedbackType) => void
  closeFeedback: () => void
  openErrorReport: (context: ErrorContext) => void
  closeErrorReport: () => void
}

export const useFeedbackStore = create<FeedbackStore>((set) => ({
  isFeedbackOpen: false,
  feedbackType: 'general',
  isErrorReportOpen: false,
  errorContext: null,

  openFeedback: (type = 'general') =>
    set({ isFeedbackOpen: true, feedbackType: type }),

  closeFeedback: () =>
    set({ isFeedbackOpen: false }),

  openErrorReport: (context) =>
    set({ isErrorReportOpen: true, errorContext: context }),

  closeErrorReport: () =>
    set({ isErrorReportOpen: false, errorContext: null }),
}))
